export const GetLocations = () =>      {return $.get('Location/GetLocations')}
export const GetMinPositions = () =>   {return $.get('Position/GetMinPositions?addOrEdit=add')} //FG - After Cert - First Release Security - added the addOrEdit Parameter
export const LicenceCheck = () =>      {return $.get('Personnel/IsLicenseMaxCountReached')}
export const AddPersonnel = (model) => {return $.post('Personnel/AddPersonnel', model)}
export const GetPersonnelMinDetailsByLocation = (locationid) => {
    //FG - FOOF - After Cert - First Release Security - THE LOC ID SHOULD NEVER BE ZERO FOR THE
    //     FIRST RELEASE.  IF IT IS THEN WE GET AN ALERT SO THE PROBLEM IS OBVIOUS!!!
    if(!locationid || locationid == 0)
        alert("THE LOCATION ID PASSED TO GetPersonnelMinDetailsByLocation IS EITHER NULL OR ZERO")
    else
        return $.get('Personnel/GetPersonnelMinDetailsByLocation?locationId='+locationid)
}



// WEBPACK FOOTER //
// ./src/pages/addpersonnel/addpersonnel.service.js